import { Table } from "antd";
import Button from "antd-button-color";
import axios from "axios";
import { BsEye } from "react-icons/bs";
import { useQuery } from "react-query";
import { serverUrl } from "../../../../nestserver";
import { ASSESSMENT_TYPES, labelsFor } from "./assessmentType";

export default function AssessmentTable({
  subjectId,
  classId,
  onClick,
  type = ASSESSMENT_TYPES.exam,
}) {
  const labels = labelsFor(type);

  async function fetchAssessments() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/exam-v2/",
      params: {
        type: type,
        subject: subjectId,
        class: classId,
      },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const assessments = useQuery(
    ["assessments", type, classId, subjectId],
    fetchAssessments,
    { enabled: !!subjectId },
  );

  const columns = [
    {
      title: `${labels.one} Name`,
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <div style={{ color: "#00627B" }} className="text-left text-sm">
          <div>{text}</div>
        </div>
      ),
    },
    {
      title: "Class & Subject",
      dataIndex: "class",
      key: "class",
      render: (text, record) => (
        <div style={{ color: "#00627B" }} className=" text-sm">
          {record.class?.name} {record.subject?.name}
        </div>
      ),
    },
    {
      title: "Total Marks",
      dataIndex: "total_marks",
      key: "total_marks",
      render: (text, record) => (
        <div style={{ color: "#00627B" }} className=" text-sm">
          {record?.total_marks}
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="flex flex-row items-center  space-x-6 pr-4">
          <Button
            shape="circle"
            className="flex items-center justify-center"
            onClick={() => {
              const newUrl = `${window.location.pathname}?action=true`;
              window.history.pushState(null, "", newUrl);
              onClick({ id: record?._id, type: type });
            }}
          >
            <BsEye className="cursor-pointer " />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Table
      loading={assessments.isLoading}
      columns={columns}
      dataSource={assessments.isSuccess && assessments.data ? assessments.data : []}
      rowKey="_id"
      pagination={false}
    />
  );
}
